/**
 * User status → first-login onboarding path.
 * 9 / 0 = must complete create-profile
 * 8 = must complete desired-partner
 * 3 = pending admin approval (after desired-partner)
 * 1 = fully active / approved
 */
export function getUserStatus(userData) {
  if (userData == null) return null;
  const raw = typeof userData === 'object' ? userData.status : userData;
  if (raw === null || raw === undefined || raw === '') return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
}

export function getOnboardingPath(status) {
  const s = getUserStatus(status);
  if (s === 9 || s === 0) return '/create-profile';
  if (s === 8) return '/desired-partner';
  if (s === 3) return '/account-pending-approval';
  if (s === 1) return null; // fully onboarded
  return null;
}

export function isFullyOnboarded(status) {
  return getUserStatus(status) === 1;
}

export function needsCreateProfile(status) {
  const s = getUserStatus(status);
  return s === 9 || s === 0;
}

export function needsDesiredPartner(status) {
  return getUserStatus(status) === 8;
}
